import { Link } from "react-router-dom";
import { LEGAL, UPDATED } from "@/lib/legal";

export default function Legal({ doc }) {
  const d = LEGAL[doc];
  return (
    <article className="max-w-3xl mx-auto px-6 py-14" data-testid={`legal-${doc}`}>
      <span className="text-xs font-semibold uppercase tracking-[0.25em] text-[#C87D53]">ConsciousLearn · The Main Source LLC</span>
      <h1 className="font-display text-4xl sm:text-5xl text-[#2C4A3E] mt-3" data-testid="legal-title">{d.title}</h1>
      <p className="text-xs text-stone-500 mt-2">Last updated {UPDATED}</p>
      <p className="mt-6 text-stone-700 leading-relaxed">{d.intro}</p>
      {d.sections.map(([h, items]) => (
        <section key={h} className="mt-8">
          <h2 className="font-display text-lg text-[#2C4A3E]">{h}</h2>
          <ul className="mt-2 space-y-2 list-disc pl-5 text-sm text-stone-700 leading-relaxed">{items.map((t) => <li key={t}>{t}</li>)}</ul>
        </section>
      ))}
      <p className="mt-12 text-sm text-stone-500">See also: <Link to="/privacy" className="underline">Privacy</Link> · <Link to="/terms" className="underline">Terms</Link> · <Link to="/refunds" className="underline">Refunds & cancelling</Link></p>
    </article>
  );
}
